import React from 'react';
import * as auth from 'ducks/auth';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LOGIN_PAGE } from 'new-design/routes/common/constants';

export const PermissionRoute = ({ component: Component, permission, ...rest }) => {
  const { sessionID } = useSelector(auth.selectors);
  const hasPermission = useSelector(auth.hasPermission);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!sessionID) {
          return (
            <Redirect
              to={{
                pathname: LOGIN_PAGE,
                state: { from: props.location },
              }}
            />
          );
        }

        if (permission && !hasPermission(permission)) {
          return (
            <Redirect
              to={{
                pathname: '/app/control-panel',
                state: { from: props.location },
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};
